import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'




const ProjectDetail4 = () => {
  return (
   <Container fluid className='project-section'>
    <div className='project-photo'>
        <div>
        <img className='img-fluid' src="https://i.ibb.co/2nP8cMW/Screen-Shot-Tool-20221211215803.png" alt="Screen-Shot-Tool-20221211190706" border="0"/>
        </div>
        <div >
        <img className='img-fluid ' src="https://i.ibb.co/m4hhCJY/Screen-Shot-Tool-20221211215707.png" alt="Screen-Shot-Tool-20221211190639" border="0"/>
        </div>
        <div >
        <img className='img-fluid ' src="https://i.ibb.co/G22X45s/Screen-Shot-Tool-20221211215625.png" alt="Screen-Shot-Tool-20221211215625"  border="0"/>
        </div>
    </div>

    <div className='my-5 w-75 mx-auto text-white '>
               <h1>Project Description</h1>
               <p >This is a simple website for just increasing the speed of typing</p>
               <ul className='text-strat'>
                 <li>USer can test thei type speed </li>
                 <li>You see some of the blogs</li> 
                <li>the website look is elegant</li>
               </ul>
               <div>
                <a className='btn btn-primary mx-1' target={"_blank"} href="https://lalon147.github.io/typing-master/">Live Site</a>
                <a className='btn btn-primary mx-1' target={"_blank"} href ="https://github.com/lalon147/typing-master">Code Link</a>

               </div>
    </div>
              

   </Container>
  )
}

export default ProjectDetail4